import { render, staticRenderFns } from "./paysInfo.vue?vue&type=template&id=35e158aa"
import script from "./paysInfo.vue?vue&type=script&lang=js"
export * from "./paysInfo.vue?vue&type=script&lang=js"
import style0 from "./paysInfo.vue?vue&type=style&index=0&id=35e158aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports